import { render, staticRenderFns } from "./CoreAccountStructureTable.html?vue&type=template&id=d93c8696&external"
import script from "./CoreAccountStructureTable.vue?vue&type=script&lang=js"
export * from "./CoreAccountStructureTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports